import GlobalBase from '../global-base';
import _ from 'lodash';

// Import Simple Lightbox and its styles.
import SimpleLightbox from 'simplelightbox';

/**
 * The JS controller for global lightboxes.
 */
class Lightbox extends GlobalBase {

    docReady() {
        this.initLightbox()
    }

    /**
     * Initialize simplelightbox for images within a columns block.
     */
    initLightbox() {
        // Set custom options.
        const lbOptions = {
            captionSelector: this.getCaption,
            captionType: 'text',
            captionPosition: 'bottom',
            animationSpeed: 150,
        };

        // Enable using permalinks without file extension (persistent files).
        lbOptions.fileExt = 'png|jpg|jpeg|gif|webp|\/';

        const items = document.querySelectorAll( `a.lightbox-item` );
        if ( items.length ) {
            new SimpleLightbox( items, lbOptions )
        }
    }

    /**
     * Try to find the caption container.
     * The container should be set as the next sibling
     * for the "lightbox-item" element with the class "lightbox-caption".
     *
     * @param {Element} item The simplelightbox image item.
     * @returns {Element}
     */
    getCaption(item) {
        if (
            _.hasIn( item, 'nextElementSibling.classList' ) &&
            item.nextElementSibling.classList.contains('lightbox-caption')
        ) {
            return item.nextElementSibling;
        }
    }

}

// Export the singleton.
export default new Lightbox();
